(() => {
  'use strict';
  const root = document.querySelector('[data-cbm-desktop-home]');
  if (!root || root.dataset.cbmNavigationReady) return;
  root.dataset.cbmNavigationReady = 'true';
  const track = root.querySelector('.cbm-desktop-category-track');
  if (!track) return;
  root.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cbm-category-prev], [data-cbm-category-next]');
    if (!button) return;
    const direction = button.hasAttribute('data-cbm-category-prev') ? -1 : 1;
    const amount = track.clientWidth / 2;
    track.scrollBy({ left: direction * amount, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
})();

(() => {
  'use strict';
  const root = document.querySelector('.cbm-desktop-storefront-header, [data-cbm-desktop-home]');
  if (!root || root.dataset.cbmHeaderNavigationReady) return;
  root.dataset.cbmHeaderNavigationReady = 'true';
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover)');
  const labels = {"auto-cars": "Auto - Cars", "clothing-and-accessories": "Clothing and Accessories", "diy": "DIY", "games-and-toys": "Games and Toys", "garden": "Garden", "health-and-beauty": "Health and Beauty", "high-tech": "High-tech", "jewelry": "Jewelry", "kitchen-and-home": "Kitchen and Home", "pet-supplies": "Pet supplies", "phone-and-accessories": "Phone and Accessories", "sport-and-fitness": "Sport and Fitness"};
  document.querySelectorAll('.header__inline-menu .header__submenu a').forEach(link => {
    const slug = new URL(link.href, location.href).pathname.split('/').filter(Boolean).pop();
    if (labels[slug]) link.textContent = labels[slug];
  });
  document.querySelectorAll('.header__inline-menu header-menu').forEach(menu => {
    const details = menu.querySelector('details');
    if (!details || menu.dataset.cbmHeaderHoverReady) return;
    menu.dataset.cbmHeaderHoverReady = 'true';
    let pointerOpened = false;
    menu.addEventListener('mouseenter', () => {
      if (!desktop.matches) return;
      pointerOpened = !details.open;
      details.open = true;
      details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    });
    menu.addEventListener('mouseleave', () => {
      if (!desktop.matches || !pointerOpened || menu.contains(document.activeElement)) return;
      details.open = false;
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      pointerOpened = false;
    });
  });
})();

(() => {
  'use strict';
  const offer = document.querySelector('[data-cbm-header-promo-offer]');
  const info = document.querySelector('[data-cbm-header-promo-info]');
  if (!offer || offer.dataset.cbmHeaderPromoReady) return;
  offer.dataset.cbmHeaderPromoReady = 'true';

  let variants = [];
  try {
    variants = JSON.parse(offer.dataset.cbmHeaderVariants || '[]');
  } catch (error) {
    return;
  }
  if (!Array.isArray(variants)) return;

  const render = (variant) => {
    const price = Number(variant?.price);
    const compareAtPrice = Number(variant?.compare_at_price);
    const hasSaving = Number.isFinite(price) && Number.isFinite(compareAtPrice) && compareAtPrice > price;
    offer.textContent = hasSaving ? `${Math.round(((compareAtPrice - price) * 100) / compareAtPrice)}% CHEAPER` : "DON'T MISS OUT";
    offer.classList.toggle('cbm-refined-announcement__discount', hasSaving);
    if (info) info.hidden = !hasSaving;
  };

  const variantForId = (id) => variants.find(variant => String(variant.id) === String(id));
  const updateFromForm = (target) => {
    const form = target?.closest?.('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    const variant = variantForId(form?.querySelector('[name="id"]')?.value);
    if (variant) render(variant);
  };

  document.addEventListener('variant:change', (event) => {
    const detail = event.detail || {};
    const candidate = detail.variant || detail.selectedVariant || detail.currentVariant;
    const variant = candidate?.id ? variantForId(candidate.id) || candidate : null;
    if (variant) render(variant);
    else window.setTimeout(() => updateFromForm(event.target), 0);
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target.closest?.('form[action*="/cart/add"]')) window.setTimeout(() => updateFromForm(event.target), 0);
  }, true);
})();
